module.exports = __webpack_public_path__ + "img/right.1145a353.png";